import { HttpClient } from '@angular/common/http';
import { computed, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  static readonly FLAGS = {
    dataRulesFolders: 'datarules_folders',
    dataRulesPreviewTextChange: 'feature_kdata_4341_datarules_preview_text_change',
    dataRulesParseResume: 'feature_kdata_3135_datarules_parse_resume_action',
    dataRulesRecordUpdateLimit: 'feature_kdata_4249_datarules_record_update_limit',
  } as const;

  private flagValues: Record<string, boolean> = {};
  private readonly ready$$ = new ReplaySubject<void>(1);
  private readonly flagValuesSignal = toSignal(this.ready$$.pipe(map(() => this.flagValues)), {
    initialValue: {} as Record<string, boolean>,
  });

  constructor(private http: HttpClient) {
  }

  init(context: { environment: string, tenant_id: string, user_id?: string, email?: string }): Observable<void> {
    return this.http.post(environment.featureFlagsUrl, context, {headers: {'x-api-key': environment.ffApiKey}}).pipe(
      map((response: any) => {
        this.flagValues = response;
      }),
      catchError(err => {
        console.warn('Failed to initialize feature flags.', err);
        return of(undefined);   // of(void 0) also works
      }),
      // Mark ready on both the success and the swallowed-error path so consumers never wait forever on a backend outage.
      tap(() => this.ready$$.next()),
    );
  }

  enabled(key: string): Signal<boolean> {
    return computed(() => this.flagValuesSignal()[key] === true);
  }
}
